import { useDispatch } from 'react-redux';
import React from 'react';
import { makeStyles } from '@mui/styles';
import { Page, Header } from 'components';
import { Grid, Button, colors } from '@mui/material';

import { ExportSites } from '../../actions/SiteTrackerActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const SiteTracker = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const _onExportSitesClick = () => {
		dispatch(ExportSites());
	};

	return (
		<Page className={classes.root} title="Site Tracker">
			<Header module="Site Tracker" view="Site Tracker" />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={6} xs={6}>
					<Grid container>
						<Button
							className={classes.generate}
							color="primary"
							onClick={_onExportSitesClick}
							variant="contained"
							size="small"
						>
							Export Sites
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Page>
	);
};

export default SiteTracker;
